import { CaterorOptions, OptionType } from "../../types/Types";



export const Options: CaterorOptions = {
    "Faiza": [
    ],
    "Auntie": [
    ],
    "Auntie2": [
    ],

}
